import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import allQuestions from "@/data/questions.json"; // Dostosuj ścieżkę!

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Losuje pytanie/wyzwanie na podstawie ustawień gry.
 *
 * @param {Array<Object>} allQuestions - Pełna lista wszystkich pytań/zadań.
 * @param {Object} settings - Obiekt ustawień gry. Powinien zawierać:
 * @param {Array<string>} types - Dozwolone typy zadań (np. ['pytanie', 'wyzwanie']).
 * @param {boolean} nsfw - Czy dozwolone są treści 18+.
 * @param {Array<number>} difficulty - Dozwolone poziomy trudności (np. [1, 2]).
 * @param {Array<string>} occasions - Dozwolone okazje (np. ['domowka']).
 * @param {Array<string>} themes - Dozwolone motywy (np. ['humor']).
 * @param {Set<string>} drawnIds - Zbiór ID pytań, które już wylosowano.
 * @returns {Object | null} Wylosowane pytanie lub null.
 */
export function getSmartRandomQuestion(allQuestions, settings, drawnIds) {
  // Teraz `allQuestions` to tablica JavaScript z Twoimi danymi.
  console.log(allQuestions[0]); // Wyświetli pierwsze pytanie

  console.log("Losowanie z ustawieniami:", settings);
  console.log("Już wylosowane:", drawnIds.size);

  // 1. Filtrowanie wstępne
  let filtered = allQuestions.filter((q) => {
    // Sprawdź typ
    if (!settings.types || !settings.types.includes(q.type)) return false;

    // Sprawdź NSFW
    if (!settings.nsfw && q.nsfw) return false;

    // Sprawdź trudność
    if (!settings.difficulty || !settings.difficulty.includes(q.difficulty))
      return false;

    // Sprawdź okazje (musi pasować przynajmniej jedna)
    if (
      !settings.occasions ||
      !q.occasions.some((occ) => settings.occasions.includes(occ))
    )
      return false;

    // Sprawdź motywy (jeśli wybrano, musi pasować przynajmniej jeden)
    if (
      settings.themes &&
      settings.themes.length > 0 &&
      !q.themes.some((theme) => settings.themes.includes(theme))
    )
      return false;

    // Jeśli wszystko pasuje
    return true;
  });

  console.log("Po filtracji:", filtered.length);

  // 2. Odrzucenie już wylosowanych
  let available = filtered.filter((q) => !drawnIds.has(q.id));
  console.log("Dostępne (nowe):", available.length);

  // 3. Obsługa wyczerpania puli
  // Jeśli nie ma nic nowego, ale są jakieś przefiltrowane,
  // pozwalamy losować ponownie z całej przefiltrowanej puli.
  // WAŻNE: Aplikacja powinna wtedy wyczyścić `drawnIds`!
  if (available.length === 0 && filtered.length > 0) {
    console.warn(
      "Pula nowych pytań wyczerpana! Losuję ponownie ze wszystkich pasujących."
    );
    available = filtered;
    // Tutaj można by zasygnalizować potrzebę resetu drawnIds
  }

  // 4. Jeśli nic nie ma, zwróć null
  if (available.length === 0) {
    console.error("Brak pytań pasujących do kryteriów!");
    return null;
  }

  // 5. Losowanie
  const randomIndex = Math.floor(Math.random() * available.length);
  const selectedQuestion = available[randomIndex];

  console.log("Wylosowano:", selectedQuestion.id);
  return selectedQuestion;
}

// --- Przykład użycia ---

// Załóżmy, że masz `allMyQuestions` wczytane z JSON
// const allMyQuestions = [ ... dane z JSON ... ];

// Załóżmy, że masz `gameSettings` i `drawnIdsSet` ze stanu swojej aplikacji
/*
const gameSettings = {
  types: ['pytanie', 'wyzwanie'], // Wybrano tryb 'classic'
  nsfw: false,                    // Tylko wersja rodzinna
  difficulty: [1, 2],             // Łagodny i średni
  occasions: ['domowka'],           // Gramy na domówce
  themes: ['humor', 'ogolne']       // Chcemy śmieszne i ogólne
};

let drawnIdsSet = new Set(); // Na początku pusty
*/

// Funkcja, którą wywołasz w grze
/*
function drawNextQuestion() {
  const selected = getSmartRandomQuestion(allMyQuestions, gameSettings, drawnIdsSet);

  if (selected) {
    console.log("Twoje zadanie:", selected.text);
    drawnIdsSet.add(selected.id); // Dodaj do wylosowanych

    // Sprawdź, czy pula się nie wyczerpała i czy nie trzeba zresetować
    // (To zależy od tego, czy funkcja losująca zwróciła coś ze starej puli)
  } else {
    console.log("Nie ma więcej pytań dla tych ustawień!");
    // Możesz zaproponować zmianę filtrów lub zakończenie gry.
  }
}
*/
